import {FC} from "react"

import {Tag} from "@frontend/components"
import {useTranslation} from "@frontend/i18n"
import {activeTheme} from "@frontend/themes/activeTheme"
import {RecommendationReason} from "@ri2/db/client"
import {css} from "@styled-system/css"

export const Reason: FC<{
  reason: RecommendationReason
}> = ({reason}) => {
  const t = useTranslation()
  return (
    <Tag
      title={t(`cause.nextStep.recommendationReason.${reason}`)}
      icon={activeTheme.assets.positiveConfirmIcon}
      colorScheme="positivePrimary"
      className={css({
        alignSelf: "flex-start",
      })}
    />
  )
}
